module.exports = __webpack_public_path__ + "static/twitter_pink-82ae252680bf18dca0b4bab495d122cb.png";